import { EditPrediction, EditedRecord } from '@modules/feedback/store/types';
import { FeedbackLabelType } from 'v2/core/entities/feedback';
import { NIL_UUID, UUID } from 'v2/core/entities/uuid';

export const getFilteredEditedRecord = (editedRecord: EditedRecord[]) => {
  // We are handling edge cases here where user can make multiple edits
  // to the same prdiction in a record. We filter out the unnecessary ones.
  return editedRecord.map((record): EditedRecord => {
    const editedPredictions = record.editPredictions;

    if (!editedPredictions) {
      return record;
    }

    const sentimentPredictionRecord: Record<UUID, EditPrediction> = {};
    const reasonOrEntityPredictionRecords: Record<UUID, EditPrediction> = {};

    editedPredictions.forEach((record) => {
      if (record.type === FeedbackLabelType.Sentiment) {
        // Sentiment don't have a id attached to them
        // This line picks up the latest added sentiment record
        sentimentPredictionRecord[NIL_UUID] = record;
        return;
      }
      reasonOrEntityPredictionRecords[record.prediction.id] = record;
    });

    return {
      ...record,
      editPredictions: [
        ...Object.values(reasonOrEntityPredictionRecords),
        ...Object.values(sentimentPredictionRecord),
      ],
    };
  });
};
